/**
 * CRTZ Theme - Main JavaScript
 * Cart drawer logic moved to cart-drawer.js
 */

(function() {
  'use strict';

  // Theme Namespace
  window.CRTZ = window.CRTZ || {};

  /**
   * Format money helper
   */
  CRTZ.formatMoney = function(cents) {
    if (typeof cents === 'undefined' || cents === null) return '£0.00';
    const value = (cents / 100).toFixed(2);
    return '£' + value;
  };

  /**
   * Newsletter Popup
   */
  CRTZ.newsletter = {
    popup: null,

    init: function() {
      this.popup = document.querySelector('[data-newsletter-popup]');
      this.bindEvents();
    },

    bindEvents: function() {
      const self = this;

      // Open from footer
      const openTrigger = document.querySelector('[data-newsletter-open]');
      if (openTrigger) {
        openTrigger.addEventListener('click', function(e) {
          e.preventDefault();
          self.open();
        });
      }

      // Close
      document.querySelectorAll('[data-newsletter-close]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          self.close();
        });
      });
    },

    open: function() {
      if (this.popup) {
        this.popup.classList.add('crtz-newsletter--open');
      }
    },

    close: function() {
      if (this.popup) {
        this.popup.classList.remove('crtz-newsletter--open');
        localStorage.setItem('newsletterClosed', 'true');
      }
    }
  };

  /**
   * Mobile Menu - Slide Down, Push Content
   */
  CRTZ.mobileMenu = {
    menu: null,

    init: function() {
      this.menu = document.querySelector('[data-mobile-menu]');
      this.bindEvents();
    },

    bindEvents: function() {
      const self = this;
      // Bind to ALL toggle buttons (there may be multiple headers)
      document.querySelectorAll('[data-mobile-menu-toggle]').forEach(function(toggle) {
        toggle.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          self.toggle();
        });
      });

      // Close button inside menu
      if (this.menu) {
        this.menu.querySelectorAll('[data-mobile-menu-close]').forEach(function(btn) {
          btn.addEventListener('click', function(e) {
            e.preventDefault();
            self.close();
          });
        });
      }

      // Close when clicking any link inside menu
      if (this.menu) {
        this.menu.querySelectorAll('a').forEach(function(link) {
          link.addEventListener('click', function() {
            self.close();
          });
        });
      }
    },

    toggle: function() {
      if (this.menu) {
        if (this.menu.classList.contains('mobile-nav--open')) {
          this.close();
        } else {
          this.open();
        }
      }
    },

    open: function() {
      if (this.menu) {
        this.menu.classList.add('mobile-nav--open');
        document.body.classList.add('menu-open');
      }
    },

    close: function() {
      if (this.menu) {
        this.menu.classList.remove('mobile-nav--open');
        document.body.classList.remove('menu-open');
      }
    }
  };

  /**
   * Mobile Menu Dropdowns
   */
  CRTZ.mobileDropdowns = {
    init: function() {
      const dropdownToggles = document.querySelectorAll('[data-dropdown-toggle]');

      dropdownToggles.forEach(function(toggle) {
        toggle.addEventListener('click', function(e) {
          e.preventDefault();
          const dropdown = this.closest('[data-dropdown]');
          if (dropdown) {
            dropdown.classList.toggle('crtz-mobile-menu__dropdown--open');
          }
        });
      });
    }
  };

  /**
   * Image Zoom
   */
  CRTZ.zoom = {
    init: function() {
      const zoomBtn = document.querySelector('[data-zoom-open]');
      if (zoomBtn) {
        zoomBtn.addEventListener('click', function() {
          const mainImg = document.querySelector('[data-product-main-image]');
          if (mainImg) {
            // Simple zoom - could be expanded to a lightbox
            mainImg.classList.toggle('zoomed');
          }
        });
      }
    }
  };

  /**
   * Cart Page - Terms validation
   */
  CRTZ.cartPage = {
    init: function() {
      const form = document.querySelector('.crtz-cart-page__form');
      if (!form) return;

      const termsCheckbox = document.getElementById('cart-terms-page');
      const checkoutBtn = form.querySelector('button[name="checkout"]');

      if (checkoutBtn && termsCheckbox) {
        checkoutBtn.addEventListener('click', function(e) {
          if (!termsCheckbox.checked) {
            e.preventDefault();
            alert('Please agree to the terms and conditions');
          }
        });
      }
    }
  };

  /**
   * Product Form - Add to cart integration
   */
  CRTZ.productForm = {
    init: function() {
      const form = document.querySelector('[data-product-form]');
      if (!form) return;

      const addButton = form.querySelector('[data-add-to-cart]');
      if (!addButton) return;

      form.addEventListener('submit', async function(e) {
        e.preventDefault();

        // Check if size is selected
        const sizeInput = form.querySelector('[data-size-input]');
        if (sizeInput && !sizeInput.value) {
          alert('Please select a size');
          return;
        }

        // Get variant ID
        const variantInput = form.querySelector('[name="id"]');
        if (!variantInput) return;

        const variantId = variantInput.value;
        const quantity = 1;

        // Show loading state
        const originalText = addButton.textContent;
        addButton.textContent = 'ADDING...';
        addButton.disabled = true;

        // Use cart drawer if available
        if (CRTZ.cartDrawer) {
          const result = await CRTZ.cartDrawer.addItem(variantId, quantity);
          if (result.success) {
            addButton.textContent = 'ADDED!';
            setTimeout(() => {
              addButton.textContent = originalText;
              addButton.disabled = false;
            }, 1500);
          } else {
            addButton.textContent = originalText;
            addButton.disabled = false;
          }
        } else {
          // Fallback: submit form normally
          form.submit();
        }
      });
    }
  };

  // Expose globally
  window.CRTZ = CRTZ;

  /**
   * Scroll Reveal Animations
   * Fade + slide up elements as they enter viewport
   */
  CRTZ.reveal = {
    init: function() {
      const revealElements = document.querySelectorAll('.crtz-product-card');
      if (!revealElements.length) return;

      // Use Intersection Observer for performance
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            // Stop observing once revealed
            observer.unobserve(entry.target);
          }
        });
      }, {
        root: null,
        rootMargin: '0px',
        threshold: 0.1 // Trigger when 10% visible
      });

      revealElements.forEach(el => observer.observe(el));
    }
  };

  /**
   * Page Transitions
   * Smooth fade between pages
   */
  CRTZ.pageTransition = {
    init: function() {
      const transition = document.querySelector('[data-page-transition]');
      if (!transition) return;

      // Fade in on page load
      document.documentElement.classList.add('page-loaded');

      // Intercept link clicks for internal navigation
      document.querySelectorAll('a').forEach(link => {
        // Only intercept same-origin links
        if (link.hostname === window.location.hostname &&
            !link.hasAttribute('data-cart-toggle') &&
            !link.hasAttribute('data-newsletter-open') &&
            !link.hasAttribute('data-mobile-menu-toggle') &&
            !link.getAttribute('href').startsWith('#') &&
            !link.hasAttribute('target')) {

          link.addEventListener('click', function(e) {
            const href = this.getAttribute('href');

            // Skip if modifier keys pressed
            if (e.ctrlKey || e.metaKey || e.shiftKey) return;

            e.preventDefault();

            // Fade out
            transition.classList.add('page-transition--out');
            document.body.classList.add('page-loading');

            // Navigate after transition
            setTimeout(function() {
              window.location.href = href;
            }, 200);
          });
        }
      });
    }
  };

  /**
   * Initialize all modules
   */
  document.addEventListener('DOMContentLoaded', function() {
    CRTZ.newsletter.init();
    CRTZ.mobileMenu.init();
    CRTZ.zoom.init();
    CRTZ.cartPage.init();
    CRTZ.productForm.init();
    CRTZ.reveal.init();
    CRTZ.pageTransition.init();
  });
})();
